import { Output, EventEmitter, AfterViewInit, Directive } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Directive()
export class ValidatableComponent implements AfterViewInit {
    @Output() validityChanged: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    form: UntypedFormGroup;

    ngAfterViewInit() {
        this.subscribeToFormStatusChange();
    }

    subscribeToFormStatusChange(): void {
        this.registerValidity();
        if (this.form) {
            this.form.updateValueAndValidity();
        }
    }

    registerValidity(): void {
        if (this.form) {
            this.form.statusChanges.subscribe((status) => {
                const isValid = status === "VALID";
                this.validityChanged.emit(isValid);
            });
        }
    }

    public isValid() {
        return this.form.valid;
    }

    public updateValidity() {
        this.form.updateValueAndValidity();
    }
}
